import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <Navbar expand="lg" variant="dark" className="site-header sticky-top" collapseOnSelect>
      <Container>
        {/* The full lockup is unreadable at header size, so the header pairs the
            ripple mark with a typeset wordmark instead. */}
        <Navbar.Brand as={Link} to="/" className="py-2 d-flex align-items-center">
          <img src="/assets/logos/art-on-the-lake-mark.png" alt="" aria-hidden="true" />
          <span className="site-header__wordmark">
            Art on the Lake
            <small>Pleasant Hill, IA</small>
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" active={isActive('/')}>Home</Nav.Link>
            <Nav.Link as={Link} to="/about" active={isActive('/about')}>About</Nav.Link>
            <Nav.Link as={Link} to="/festival" active={isActive('/festival')}>Festival</Nav.Link>
            <Nav.Link as={Link} to="/gallery" active={isActive('/gallery')}>Gallery</Nav.Link>
            <Nav.Link as={Link} to="/sponsors" active={isActive('/sponsors')}>Sponsors</Nav.Link>
            <Nav.Link as={Link} to="/contact" active={isActive('/contact')}>Contact</Nav.Link>
          </Nav>
          <div className="d-flex ms-lg-3 mt-3 mt-lg-0">
            <Link to="/donate" className="btn btn-primary btn-sm px-3">Donate</Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
